import type { DockMapObject, Point3D } from "../types";

export interface DockRaw {
    id: string | number;
    name: string;
    position: Point3D;
    yaw: number;
    powered?: boolean;
    calibrationPointOffset?: Point3D;
    returnPointOffset?: Point3D;
    [key: string]: unknown;
}

export function parseDocks(
    docks: DockRaw[] | null | undefined,
): DockMapObject[] {
    if (!Array.isArray(docks)) return [];

    return docks.map((dock) => ({
        id: String(dock.id),
        type: "dock",
        label: dock.name,
        x: dock.position.x,
        y: dock.position.y,
        z: dock.position.z,
        yaw: dock.yaw,
        ...(dock.powered !== undefined ? { powered: dock.powered } : {}),
        ...(dock.calibrationPointOffset !== undefined
            ? { calibrationPointOffset: dock.calibrationPointOffset }
            : {}),
        ...(dock.returnPointOffset !== undefined
            ? { returnPointOffset: dock.returnPointOffset }
            : {}),
        interactive: true,
    }));
}
